import { if_undefined, is_intersect } from "./math_functions.js"
import { Simple_value_constructor } from "./simple_value.js"
import { Conditional_action } from "./conditional_action.js"
import { Timer } from "./timer.js"
import {  UniversalSocket } from "./ability_container.js"

var cooldown_affect_traits =  new Set(['melee_regen_rate', 'grenade_regen_rate', 'class_regen_rate', 'mobility', 'resilience', 'recovery', 'discipline', 'intellect', 'strength', 'class_stat']);
var stat_affect_traits = new Set(['mobility', 'resilience', 'recovery', 'discipline', 'intellect', 'strength', 'class_stat']);
var damage_affect_traits = new Set(['grenade_damage', 'melee_damage', 'super_damage', 'ability_damage', 'charged_melee_damage','basic_melee_damage',]);


class Sandbox_item
{
    constructor(master, data)
    {
        this.master = master;
        // common fields
        this.id = data.id;
        this.type = data.type;

        this.breaker_type = if_undefined(data, "breaker_type", null); // <-data

        this.active_duration = if_undefined(data, "active_duration", "infinite"); // <-data
        this.activation_condition = if_undefined(data, "activation_condition", null); // <-data
        this.max_stack = if_undefined(data, "max_stack", 1); // <-data

        // simple_value containers
        
        this.template = {
            pve: "",
            pvp: ""
        };
        
        this.data = {
            pvp: new Array(),
            pve: new Array()
        };

        // list of granted effects
        this.grants = if_undefined(data, "grants", null); // <-data

        // common constructed fields
        this.counter = 0; // how many it is granted, counter == 0 -> means tile with description is not present
        this.relations = new Set();
        this.current_stack = 0;
        this.is_active = false;

        if (this.active_duration == "timer")
            this.duration = new Timer(); // for buff that affect cooldowns
        else
            this.duration = null;

        // are they needed?
        this.affect_cooldowns = false;
        this.affect_stats = false;
        this.affect_damage = false;
        // ??

        this.conditional_actions = null; // <-data

        // assigning values
        if ('common_template' in data)
        {
            this.template.pve = data.common_template;
            this.template.pvp = data.common_template;
        }
        else
        {
            if ('pvp_template' in data)
                this.template.pvp = data.pvp_template;

            if ('pve_template' in data)
                this.template.pve = data.pve_template;
        }

        // simple_value containers
        if ('common_data' in data)
        {
            for (let index in data.common_data)
            {
                let simple_value = Simple_value_constructor(this, data.common_data[index]);
                this.data.pvp.push(simple_value);
                this.data.pve.push(simple_value);

                this.relations.add(simple_value.get_relates_to());
            }
        }

        if ('pvp_data' in data)
        {
            for (let index in data.pvp_data)
            {
                let simple_value = Simple_value_constructor(this, data.pvp_data[index]);
                this.data.pvp.push(simple_value);
                this.relations.add(simple_value.get_relates_to());
                if (this.id == "whisper_of_shards_improved_ability_regeneration_effect")
                {
                    console.log("%^%", simple_value.get_relates_to())
                }
            }
        }

        if ('pve_data' in data)
        {
            for (let index in data.pve_data)
            {
                let simple_value = Simple_value_constructor(this, data.pve_data[index]);
                this.data.pve.push(simple_value);
                this.relations.add(simple_value.get_relates_to());
                if (this.id == "whisper_of_shards_improved_ability_regeneration_effect")
                {
                    console.log("%^%", simple_value.get_relates_to())
                }
            }
        }

        // list of granted effects

        if ('conditional_actions' in data)
        {
            if (data.conditional_actions !== null)
            {
                this.conditional_actions = new Array();

                for (let action of data.conditional_actions)
                {
                    //console.log(action);
                    this.conditional_actions.push(new Conditional_action(action));
                }
            }
        }

        // unsure if they are still needed
        if (is_intersect(this.relations, cooldown_affect_traits))
            this.affect_cooldowns = true;

        if (is_intersect(this.relations, stat_affect_traits))
            this.affect_stats = true;

        // TODO: problem, grenades also have fields with grenade damage, so need to check combo of type and relates_to

        if (is_intersect(this.relations, damage_affect_traits))
            this.affect_damage = true;
    }

    get_duration()
    {
        if (this.duration != null)
            return this.duration.get();
        return null;
    }

    set_duration(val)
    {
        if (this.duration != null)
            this.duration.set(val);
    }

    get_template(sandbox)
    {
        if (sandbox == 'pvp')
            return this.substitute_template(this.template.pvp, this.data.pvp);
        if (sandbox == 'pve')
            return this.substitute_template(this.template.pve, this.data.pve);
        return '';
    }

    substitute_template(template, data)
    {
        if (!this.is_active)
            return "(Effect inactive)";

        let t = template; // copying template

        for (var simple_effect of data)
        {
            if (simple_effect.get_template_index() !== null)
            {
                t = t.replaceAll("{$" + simple_effect.get_template_index() + "}", simple_effect.get_rounded_value());
            }
        }
        return t;
    }

    set_stack(stack) // stack is from 0 [inactive] to 1, 2, 3 .. N [have stack]
    {
        if (this.max_stack == null)
           this.current_stack = stack;
        else if (stack > this.max_stack)
            stack = this.max_stack;
        else
            this.current_stack = stack;
    }

    set_activity(val)
    {
        this.is_active = val;
    }

    reset(sandbox)
    {
        if (sandbox == "pvp")
            this.data.pvp.forEach((simple_value) => simple_value.reset(this.current_stack));
        else
            this.data.pve.forEach((simple_value) => simple_value.reset(this.current_stack));
    }

    apply(other, sandbox) // other effect is applied to this one
    {
        if (sandbox == 'pvp')
        {
            for (var simple_value_a of this.data.pvp)
            {
                if (simple_value_a.get_type() == 'stat')
                {
                    for (var simple_value_b of other.data.pvp)
                    {
                        if (simple_value_b.get_type() != 'stat' && simple_value_a.get_relates_to() == simple_value_b.get_relates_to())
                        {
                            console.log("\t|->", simple_value_a, simple_value_b)
                            simple_value_a.apply(simple_value_b);
                        }
                    }
                }
            }
        }
        else if (sandbox == 'pve')
        {
            for (var simple_value_a of this.data.pve)
            {
                if (simple_value_a.get_type() == 'stat')
                {
                    for (var simple_value_b of other.data.pve)
                    {
                        if (simple_value_b.get_type() != 'stat' && simple_value_a.get_relates_to() == simple_value_b.get_relates_to())
                        {
                            console.log("\t|->", simple_value_a, simple_value_b)
                            simple_value_a.apply(simple_value_b);
                        }
                    }
                }
            }
        }
    }

    check_condition(condition)
    {
        return this.master.check_condition(condition);
    }

    calculate_formula(formula)
    {
        return this.master.calculate_formula(formula);
    }

    get_simple_values(sandbox)
    {
        if (sandbox == 'pvp')
            return this.data.pvp;
        if (sandbox == 'pve')
            return this.data.pve;
        return [];
    }

    get_id()
    {
        return this.id;
    }
}

export class Perk extends Sandbox_item
{
    constructor(master, data)
    {
        super(master, data);
        this.display_properties = data.display_properties;
        this.visibility = if_undefined(data, "visibility", "visible"); // <-data

        this.subtype = if_undefined(data, "subtype", "nosubtype");

        this.activation = if_undefined(data, "activation", "auto"); // <-data

        if (this.subtype == "blue_armor_mod")
            this.duration = master.get_armor_charge_timer(); // for buff that affect cooldowns
    }

    static create(master, data)
    {
        if ( data == null )
            return null
        else
            return new Perk(master, data)
    }
}

export class Item
{
    constructor(master, data)
    {
        this.master = master;
        // common fields
        this.id = data.id;
        this.type = data.type;

        //super(master, data)
        this.display_properties = if_undefined(data, "display_properties", null);
        this.visibility = if_undefined(data, "visibility", "visible"); // <-data

        if (this.pve_template == '' && this.pvp_template == "")
            this.visibility = "hidden";

        this.perks = if_undefined(data, "perks", []);

        // activation and stacks
        this.activation = if_undefined(data, "activation", "auto"); // <-data

        this.investment_stats = if_undefined(data, "investment_stats", null);
        this.trait_ids = if_undefined(data, "trait_ids", null);

        // list of granted effects
        this.grants = if_undefined(data, "grants", null); // <-data
    }
}

class Complex_effect extends Sandbox_item
{
    constructor(master, data)
    {
        super(master, data)
        this.display_properties = if_undefined(data, "display_properties", null);
        this.visibility = if_undefined(data, "visibility", "visible"); // <-data

        // activation and stacks
        this.activation = if_undefined(data, "activation", "toggle"); // <-data
    }
}

export class Ability extends Sandbox_item /// Item // always, infinite
{
    constructor(master, data)
    {
        super(master, data);

        ///////////////////////// part of Item (originally)
        this.display_properties = if_undefined(data, "display_properties", null);
        this.visibility = if_undefined(data, "visibility", "visible"); // <-data

        if (this.template.pve == '' && this.template.pvp == "")
            this.visibility = "hidden";

        this.perks = if_undefined(data, "perks", []);

        // activation and stacks
        this.activation = if_undefined(data, "activation", "auto"); // <-data

        this.investment_stats = if_undefined(data, "investment_stats", null);
        this.trait_ids = if_undefined(data, "trait_ids", null);
        ///////////////////////

        this.element = data.element;
        this.subclass = data.subclass;

        // basically a pointer to simple effect storing cooldown
        this.cooldown = null;
        if (data.cooldown != null)
        {
            this.cooldown = Simple_value_constructor(this, data.cooldown);
            this.cooldown.reset(1);
        }

        this.charges = 1;

        if ('charges' in data)
        {
            this.charges = data.charges;
        }
    }

    get_cooldown()
    {
        if (this.cooldown == null)
            return null;
        else
            return this.cooldown.value;
    }

    get_element()
    {
        return this.element;
    }
}

export class Class extends Item
{
    constructor(master, data)
    {
        super(master, data);
        this.exotic_armor = data.exotic_armor;

        this.subclasses = new Map;
        for (let subclass_element in data.subclasses)
            this.subclasses.set(subclass_element, data.subclasses[subclass_element]);
    }
}

export class Subclass extends Item
{
    constructor(master, data)
    {
        super(master, data);

        this.subclass_element = data.subclass_element;
        this.supers = data.supers;
        this.aspects = data.aspects;
        this.fragments = data.fragments;
        this.melees = data.melees;
        this.class_abilities = data.class_abilities;
        this.grenades = data.grenades;
    }
}

export class Entity extends Complex_effect // always, infinite
{
    constructor(master, data)
    {
        super(master, data);
        this.activation = 'auto';
        this.active_duration = 'infinite';
    }
}

export class Buff extends Complex_effect // toggle, timer
{
    constructor(master, data)
    {
        super(master, data);

        // basically a pointer to simple effect with .is_attribute == 'default_duration'
        this.pvp_default_duration = null;
        this.pve_default_duration = null;

        console.log(this, data)


        for (let effect of this.data.pvp)
        {
            if (effect.is_attribute == 'default_duration')
            {
                this.pvp_default_duration = effect;
            }
        }

        for (let effect of this.data.pve)
        {
            if (effect.is_attribute == 'default_duration')
            {
                this.pve_default_duration = effect;
            }
        }
    }

    get_default_duration(sandbox)
    {
        if (sandbox == 'pvp')
        {
            if (this.pvp_default_duration != null)
                return this.pvp_default_duration.value;
            else
                return null;
        }
        else if (sandbox == 'pve')
        {
            if (this.pve_default_duration != null)
                return this.pve_default_duration.value;
            else
                return null;
        }
    }
}

export class Fragment extends Item // always, infinite
{
    constructor(master, data)
    {
        super(master, data);

        ///////////////////////// part of Item (originally)
//        this.display_properties = if_undefined(data, "display_properties", null);
//        this.visibility = if_undefined(data, "visibility", "visible"); // <-data
//
//        if (this.template.pve == '' && this.template.pvp == "")
//            this.visibility = "hidden";
//
//        this.perks = if_undefined(data, "perks", []);
//
//        // activation and stacks
//        this.activation = if_undefined(data, "activation", "auto"); // <-data
//
//        this.investment_stats = if_undefined(data, "investment_stats", null);
//        this.trait_ids = if_undefined(data, "trait_ids", null);
        ///////////////////////


        this.subclass = data.subclass;
        this.element = data.element;
    }
}

export class Aspect extends Fragment // -> always, infinite
{
    constructor(master, data)
    {
        super(master, data);

        this.flavor_text = "";

        if ("flavor_text" in data)
            this.flavor_text = data.flavor_text;

        this.fragment_capacity = data.fragment_capacity;
    }
}

export class Exotic_Armor extends Item // always, infinite
{
    constructor(master, data)
    {
        super(master, data);

        this.class = data.class;
        this.armor_slot = data.armor_slot;
        this.display_type = data.display_type;
        this.rarity = "exotic";
    }
}

export class Exotic_Weapon extends Item // always, infinite
{
    constructor(master, data)
    {
        super(master, data);

        this.weapon_slot = data.weapon_slot;
        this.rarity = "exotic";
    }
}

export class Armor_mod extends Item // always, infinite
{
    constructor(master, data)
    {
        super(master, data);
        //TODO: need to do something with mods

        this.armor_slot = data.armor_slot;
        this.stackable = data.stackable
        // mod type
        this.mod_type = data.mod_type;
    }
}

export class Activity extends Item // always, infinite
{
    constructor(master, data)
    {
        super(master, data);

        this.sandbox = data.sandbox;

        if ('total_multiplier' in data)
            this.total_multiplier = data.total_multiplier;
        else if (this.sandbox == 'pve')
        {
            this.total_multiplier = 1;
        }
    }
}

export class Armor // extends Item (for the future)
{
    constructor(id, masterItem, armorType, armorSlot)
    {
        this.id = id;
        this.type = armorType;
        this.masterItem = masterItem;
        this.armorSlot = armorSlot;

        this.stats_ = {
            "mobility": 0,
            "resilience": 0,
            "recovery": 0,
            "discipline": 0,
            "intellect": 0,
            "strength": 0,
            "any_energy": 0,
        };

        this.sockets = {
            entries: {
                general_armor_mod: new UniversalSocket(this, this.masterItem.effects, 'general_armor_mod'),
                [`${armorSlot}_armor_mod_0`]: new UniversalSocket(this, this.masterItem.effects, `${armorSlot}_armor_mod`, 0),
                [`${armorSlot}_armor_mod_1`]: new UniversalSocket(this, this.masterItem.effects, `${armorSlot}_armor_mod`, 1),
                [`${armorSlot}_armor_mod_2`]: new UniversalSocket(this, this.masterItem.effects, `${armorSlot}_armor_mod`, 2),
            },
            categories: {
                general_armor_mod: ["general_armor_mod"],
                [`${armorSlot}_armor_mod`]: [`${armorSlot}_armor_mod_0`, `${armorSlot}_armor_mod_1`, `${armorSlot}_armor_mod_2`]
            }
        }
    }

    updateStats(statsChanges)
    {
        console.log("armorpiece: updateStats", statsChanges);

        for (let statId in statsChanges)
        {
            if (statsChanges[statId] != 0)
            {
                console.log('stat changed', statId, statsChanges[statId]);

                switch (statId)
                {
                    case "mobility":
                    case "resilience":
                    case "recovery":
                    case "discipline":
                    case "intellect":
                    case "strength":
                        this.stats_[statId] += statsChanges[statId];
                        break;
                    case "any_energy": // TODO: more in the future
                        this.stats_[statId] += statsChanges[statId];
                        break;
                }
            }
        }

        // changes bubble to master
        if ("updateStats" in this.masterItem)
        {
            console.log("armorpiece called character updateStats", )
            this.masterItem.updateStats(statsChanges);
        }
    }

    plugInSocket(itemId, socketCategory, socketIndex, updating=true)
    {
        let soketKey = this.sockets.categories[socketCategory][socketIndex];
        this.sockets.entries[soketKey].set(itemId);

        if (updating)
        {
            this.masterItem.effects.apply_effects();
            this.masterItem.calc_all_cooldowns();
        }
    }
}
